module.exports = __webpack_public_path__ + "1f1f5e3abe1fc28899151f53a4cd9bb9.png";